module.exports = __webpack_public_path__ + "img/heart.53b941a8.svg";